import { Shield } from "lucide-react";
import { useDevRoleOverride, isDevelopmentMode } from "@/lib/utils/devRoleOverride";
import { useSimplifiedUserData } from "@/providers/SimplifiedUserDataProvider";
import { getCompanyRoles } from "@/lib/utils/permissions";

/**
 * Visual indicator that shows when dev role override is active
 * Appears in the top-right corner of the screen
 */
export default function DevRoleIndicator() {
  const { overrideRoleId } = useDevRoleOverride();
  const { selectedCompany } = useSimplifiedUserData();

  // Don't render if not in development mode or no override is active
  if (!isDevelopmentMode() || !overrideRoleId || !selectedCompany) {
    return null;
  }

  const roles = getCompanyRoles(selectedCompany.id);
  const overrideRole = roles.find(r => r.id === overrideRoleId);

  if (!overrideRole) {
    return null;
  }

  return (
    <div className="fixed top-2 right-2 z-50 flex items-center gap-2 px-3 py-1.5 bg-orange-100 dark:bg-orange-900/30 border border-orange-400 dark:border-orange-600 rounded-md shadow-lg">
      <Shield className="h-4 w-4 text-orange-600 dark:text-orange-400" />
      <span className="text-xs font-medium text-orange-800 dark:text-orange-300">
        Dev Role: {overrideRole.role_name}
      </span>
    </div>
  );
}

